import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleTestPackageModel from "../../models/lab/SampleTestPackageModel";

/**
 * SampleTestPackage collection
 */
export default class SampleTestPackageCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return SampleTestPackageModel;
  }

}
